<!--
Author: TangChen
Date: 2019-08-13
Desc: 理财知识页面，由router.js 配置引入
 -->
<template>
    <div :class="'bizcomp-info-publish bizcomp ' + className">
        <comp-title :title="title"></comp-title>
        <div class="info-box">
            <el-row class="fund-filter">
                <el-col :span="24" class="btn-fund">
                    <el-col :span="6">
                        基金名称：
                        <div style="display: inline-block">
                            <el-input
                                v-model="keyword"
                                placeholder="请输入基金名称或基金代码"
                                class="input-search"
                                size="small"
                            />
                        </div>
                    </el-col>
                    <!-- <el-col :span="6">
                        公告标题：
                        <div style="display: inline-block;">
                            <el-input
                                v-model="infotitle"
                                placeholder="请输入公告标题"
                                class="input-search"
                                size="small"
                            />
                        </div>
                    </el-col> -->
                    <el-col :span="12">
                        更新日期：
                        <div class="custom-time">
                            <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                            <el-button
                                size="small"
                                type="yellow"
                                v-on:click.prevent="getFinanceNews"
                            >
                                查询
                            </el-button>
                        </div>
                    </el-col>
                </el-col>
            </el-row>
            <div class="info">
                <template v-if="financeNews.length > 0">
                    <div v-for="(list, i) in financeNews" :key="i" class="info-list-child">
                        <a
                            v-if="list.isopenfile == '2'"
                            v-on:click="
                                $router.push({ name: 'knowdetail', query: { id: list.id } })
                            "
                        >
                            <span class="text">{{ list.title }}</span>
                            <span v-if="list.fileid" class="right font-light">
                                {{ list.updatetime }}
                            </span>
                        </a>
                        <a v-else :href="$util.src('/common/download', { id: list.fileid })">
                            <span class="text">{{ list.title }}</span>
                            <span v-if="list.fileid" class="right font-light">
                                {{ list.updatetime }}
                            </span>
                        </a>
                    </div>
                    <el-row v-if="Number(allPage) > Number(pagecount)" class="page-box">
                        <el-pagination
                            :page-size="Number(pagecount)"
                            layout="prev, pager, next"
                            background
                            :total="Number(allPage)"
                            v-on:current-change="nextPage"
                        ></el-pagination>
                    </el-row>
                </template>
                <div v-else class="no-data">暂无数据</div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import datePicker from "@/components/form/datePicker";
export default {
    name: "InfoKnowledge",
    components: {
        datePicker
    },
    mixins: [mixin],
    props: {
        styleid: {
            type: String,
            default: ""
        },
        active: {
            type: String,
            default: ""
        },
        menuInfo: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            keyword: "",
            infotitle: "",
            download: {},
            index: "",
            query: null,
            financeNews: [],
            begindate: "",
            enddate: "",
            pagecount: "0",
            pageoffset: "0",
            allPage: "0",
            total: "0",
            dateSet: { type: "2", min: "1990-01-01", size: "mini" }
        };
    },
    watch: {
        index(val) {
            this.pageoffset = "0";
            if (this.query !== null) {
                this.query = setTimeout(() => {
                    this.getFinanceNews();
                    clearTimeout(this.query);
                    this.query = null;
                }, 500);
                return;
            }
            this.getFinanceNews();
        }
    },
    mounted() {
        if (this.$route.query.index) {
            this.index = this.$route.query.index;
        }
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        // this.pagecount = "5";
        this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
        this.getFinanceNews();
    },
    methods: {
        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.begindate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.enddate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        nextPage(val) {
            this.pageoffset = (val - 1) * this.pagecount;
            if (this.query !== null) {
                this.query = setTimeout(() => {
                    this.getFinanceNews();
                    clearTimeout(this.query);
                    this.query = null;
                }, 500);
                return;
            }
            this.getFinanceNews();
        },
        getFinanceNews() {
            const _this = this;
            const _x = {
                pagecount: _this.pagecount,
                pageoffset: _this.pageoffset,
                begindate: _this.begindate,
                enddate: _this.enddate,
                keyword: _this.keyword,
                title: _this.infotitle
            };
            this.$util.request("umpf/special/notice", _x).then((res) => {
                if (res.data) {
                    _this.financeNews = res.data;
                    _this.allPage = res.alllength || "0";
                }
            });
        }
    }
};
</script>
<style lang="scss">
.bizcomp-info-publish {
    /*自定义时间控件*/
    .custom-time {
        display: inline-block;
        vertical-align: middle;
        .comp-date-picker {
            width: auto;
        }
        .el-button {
            min-width: 100px;
            padding: 8px 15px;
            margin-left: 13px;
        }
    }
    .no-data {
        text-align: center;
    }
    .info-box {
        padding: 20px 24px;
        .info {
            margin-top: 30px;
        }
    }
    .info-list-child {
        line-height: 48px;
        border-bottom: 1px dashed #cfcfcf;
        &.first {
            margin-top: 10px;
        }
        a {
            color: #333333;
        }
        span {
            vertical-align: middle;
            &:first-child {
                display: inline-block;
                height: 48px;
                width: 80%;
                cursor: pointer;
            }
        }
        &:before {
            content: "";
            display: inline-block;
            width: 5px;
            height: 5px;
            margin-right: 10px;
            border: 1px solid #666666;
            border-radius: 50%;
            vertical-align: middle;
        }
    }
}
</style>
